// This is a mock service - in production, this would connect to your backend
export const submissionService = {
    // Get all submissions
    getSubmissions: async () => {
      try {
        // In production, this would be an API call
        const submissions = JSON.parse(localStorage.getItem('researchSubmissions') || '[]');
        return submissions;
      } catch (error) {
        console.error('Error fetching submissions:', error);
        throw error;
      }
    },
  
    // Add new submission
    addSubmission: async (submissionData) => {
      try {
        // In production, this would be an API POST request
        const submissions = JSON.parse(localStorage.getItem('researchSubmissions') || '[]');
        const newSubmission = {
          ...submissionData,
          id: Date.now(),
          submittedAt: new Date().toISOString(),
          status: 'pending'
        };
        submissions.push(newSubmission);
        localStorage.setItem('researchSubmissions', JSON.stringify(submissions));
        return newSubmission;
      } catch (error) {
        console.error('Error adding submission:', error);
        throw error;
      }
    },
  
    // Update submission status
    updateSubmission: async (id, status) => {
      try {
        // In production, this would be an API PUT request
        const submissions = JSON.parse(localStorage.getItem('researchSubmissions') || '[]');
        const updatedSubmissions = submissions.map(sub => 
          sub.id === id ? { ...sub, status } : sub
        );
        localStorage.setItem('researchSubmissions', JSON.stringify(updatedSubmissions));
        return true;
      } catch (error) {
        console.error('Error updating submission:', error);
        throw error;
      }
    }
  };